import { FaHome, FaCloudUploadAlt, FaRocketchat, FaUserTie, FaWhatsapp, FaRobot } from "react-icons/fa";
import AddCustomers from "../pages/AddCustomers";
import Dashboard from "../pages/Dashboard";
import { Profile } from "../pages/Profile";
import SentimentAnalysis from "../pages/SentimentAnalysis";
import { WhatsappOnboarding } from "../pages/WhatsappOnboarding";
import {AIAgent} from "../pages/AIAgent";

export const privateRoutes = [
    {

        path: ":feedbackType",
        component: <Dashboard />,
        label: "Dashboard",
        icon: <FaHome />, showInSideBar: true,
    },
    {
        path: "add-customer",
        component: <AddCustomers />,
        label: "Upload File",
        icon: <FaCloudUploadAlt />, showInSideBar: true,
    },
    {
        path: "sentiment-analysis",
        component: <SentimentAnalysis />,
        label: "Sentiment Analysis",
        icon: <FaRocketchat />, showInSideBar: true,
    },
    {
        path: "profile",
        component: <Profile />,
        label: "Profile",
        icon: <FaUserTie />, showInSideBar: true,
    },
    {
        path: "whatsapp-onboarding",
        component: <WhatsappOnboarding />,
        label: "Whatsapp Onboarding",
        icon: <FaWhatsapp />, showInSideBar: true,
    },
    {
        path: "ai-agent",
        component: <AIAgent />,
        label: "AI Agent",
        icon: <FaRobot />, showInSideBar: true,
    },
]